// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__nngpR","title":"BackImages_title__r4-Bt","images":"BackImages_images__KaAln"};